<ng-container>
  <div class="sticky">
    <div class="">
      <div class="">
        <div class="btn-group">
          @if (step > 1) {
            <pr-button
              data-testid="dashboard-souscription-funnel-prev"
              size="lg"
              type="button"
              [label]="prevLabel"
              icon="arrow_left"
              [disabled]="disabledPrev"
              (onClick)="onPrev()"
            ></pr-button>
          }

          @if (!hideSendCompletion) {
            <pr-button
              data-testid="dashboard-souscription-funnel-send-completion"
              size="lg"
              type="button"
              [display]="displaySendCompletion"
              [label]="sendCompletion"
              (onClick)="onSendCompletionSubscription()"
              style="margin-left: auto"
              [disabled]="disabledSendCompletion"
            />
          }

          @if (!leadEmailSend) {
            <pr-button
              data-testid="dashboard-souscription-funnel-next"
              size="lg"
              type="button"
              [display]="displayNext"
              [label]="nextLabel"
              (onClick)="onNext()"
              style="margin-left: auto"
              [disabled]="disabledNext"
            ></pr-button>
          }
          @if (sessionConsultant && !leadEmailSend) {
            <pr-icon
              data-testid="dashboard-souscription-funnel-next-mandatory"
              [attr.disabled]="disabledSkip || disabledSkipBtn"
              [class.linkDisabled]="disabledSkip || disabledSkipBtn"
              [attr.title]="'Question obligatoire suivante'"
              (click)="notifyClick()"
              class="right-icon forward ng-star-inserted"
              _nghost-fxs-c169=""
            >
              <i class="fa fa-solid fa-forward"></i>
            </pr-icon>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
